import { securePost } from "config/encryption_decryption/get_post_encryptDecrypt";

export const requestPointsClaimApi = {
  insertPoints: async (payload) => {
    return securePost("/api/survey/addClaimRequests", {
      body: {
        data: payload,
      },
    });
  },
};